<template>

  <Start/>
</template>

<script>
import Start from './components/Start.vue'

export default {
  name: 'App',
  components: {
    Start
  }
}
</script>

<style>
/* Reserve the vertical scrollbar gutter permanently so page content (incl. the
   top nav buttons) doesn't shift left when the scrollbar toggles on/off — e.g.
   when the date-picker calendar opens or a long transactions list renders. */
html {
  scrollbar-gutter: stable;
  overflow-y: scroll;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
</style>
